import axios from 'axios';
import querystring from 'querystring';
import { apiUrl, getToken } from './utils';

const baseURL = apiUrl();
const token = getToken();

/**
 * Auth
 */
// Without header call
const instance = axios.create({
  baseURL: baseURL,
});

// With header call
const authInstance = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// Updating authtoken in authInstance after login/register
const updateToken = (authToken) => {
  authInstance.defaults.headers['Authorization'] = `Bearer ${authToken}`;
};

const login = (values) => {
  // Call The login function
  return instance.post('/auth/local', {
    identifier: values.email,
    password: values.password,
  });
};

const register = (values) => {
  // Call The login function
  return instance.post('/auth/local/register', { ...values, username: values.email });
};

const providerLogin = (values) => {
  // Call The login function
  return instance.get(`/stb-users/auth/${values.provider}/callback${values.params}`);
};

const forgotPassword = async (values) => {
  // Call The login function
  return await instance.post('/auth/forgot-password', values);
};

const emailConfirmation = async (params) => {
  // Call The login function
  // return await instance.get(`/auth/email-confirmation?${querystring.stringify(params)}`); // core
  return await instance.get(`/auth/confirm-email?${querystring.stringify(params)}`); // custom
};

const resetPassword = async (values) => {
  // Call The login function
  return await instance.post('/auth/reset-password', values);
};

const updateProfile = (params) => {
  return authInstance.put(`/users/${params.id}`, params);
};

const getUserProfile = (params) => {
  return authInstance.get('/users/me', params);
};

/**
 * User objects
 */

const getUserobjects = (params) => {
  return authInstance.get(`/stb-users/userobjects?${querystring.stringify(params)}`);
};

const createUserobject = (params) => {
  return authInstance.post('/stb-users/userobjects', params);
};

const updateUserobject = (params) => {
  return authInstance.put(`/stb-users/userobjects/${params.id}`, params);
};

const deleteUserobject = (params) => {
  return authInstance.delete(`/stb-users/userobjects/${params.id}`, params);
};

const getProperties = (params) => {
  return instance.get(`/properties?${querystring.stringify(params)}`);
};

const unsubscribe = (params) => {
  return instance.put(`/stb-users/alert/property/unsubscribe`, params);
};

const getProperty = (params) => {
  return authInstance.get(`/myaccount/propertydetails/${params.id}`);
};

/**
 * Form
 */

const postForm = (params) => {
  return authInstance.post('/stb-forms/forms', params);
};

/**
 * Myaccount
 */

// get
const getDashboardData = (params) => {
  return authInstance.get(`/myaccount/dashboard?${querystring.stringify(params)}`);
};

const getMypropertiesData = (params) => {
  return authInstance.get(`/myaccount/myproperties?${querystring.stringify(params)}`);
};

const getMytenanciesData = (params) => {
  return authInstance.get(`/myaccount/mytenancies?${querystring.stringify(params)}`);
};

const getMyoffersData = (params) => {
  return authInstance.get(`/myaccount/myoffers?${querystring.stringify(params)}`);
};

const getMyappointmentsData = (params) => {
  return authInstance.get(`/myaccount/myappointments?${querystring.stringify(params)}`);
};

const getActivityData = (params) => {
  return authInstance.get(`/myaccount/activity?${querystring.stringify(params)}`);
};

const getPendingActionData = (params) => {
  return authInstance.get(`/myaccount/pendingactions?${querystring.stringify(params)}`);
};

const getPendingActionCount = (params) => {
  return authInstance.get(`/myaccount/pendingactions?count=true&${querystring.stringify(params)}`);
};

// Post
const postAppointment = (params) => {
  return authInstance.post(`/myaccount/post-appointment`, params);
};

// Property

const getPropertyAppointments = (params) => {
  return authInstance.get(
    `/myaccount/propertydetails/${params.property_id}/appointments?${querystring.stringify(params)}`
  );
};

const getPropertyFeedbacks = (params) => {
  return authInstance.get(`/myaccount/propertydetails/${params.property_id}/feedbacks`);
};

const getPropertyOffers = (params) => {
  return authInstance.get(`/myaccount/propertydetails/${params.property_id}/offers`);
};

const getPropertyTenancies = (params) => {
  return authInstance.get(`/myaccount/propertydetails/${params.property_id}/tenancies`);
};

const getPropertyTransactions = (params) => {
  return authInstance.get(`/myaccount/propertydetails/${params.property_id}/transactions`);
};

const getPropertyTasks = (params) => {
  return authInstance.get(`/myaccount/propertydetails/${params.property_id}/tasks`);
};

const getWorksOrders = (params) => {
  return authInstance.get(`/myaccount/propertydetails/${params.property_id}/worksorders`);
};

export {
  // myaccount
  getDashboardData,
  getMypropertiesData,
  getMytenanciesData,
  getMyoffersData,
  getMyappointmentsData,
  postAppointment,
  getActivityData,
  getPendingActionData,
  getPendingActionCount,
  // Property
  getPropertyAppointments,
  getPropertyFeedbacks,
  getPropertyOffers,
  getPropertyTenancies,
  getPropertyTransactions,
  getPropertyTasks,
  getWorksOrders,
  // auth
  updateToken,
  login,
  register,
  getUserobjects,
  providerLogin,
  forgotPassword,
  resetPassword,
  getUserProfile,
  updateProfile,
  getProperties,
  getProperty,
  createUserobject,
  updateUserobject,
  deleteUserobject,
  emailConfirmation,
  postForm,
  unsubscribe,
};
